import { database } from '@shared/database'
import spotworkAPI from '@shared/spotwork'
import { auth } from '@/components/utils/firebase'

export default {
  namespaced: true,
  state: {
    offerCount: 0,
    isInitialized: false
  },
  mutations: {
    setOfferCount(state, count) {
      state.offerCount = count
    },
    setIsInitialized(state, value) {
      state.isInitialized = value
    }
  },
  actions: {
    updateOfferCount({ commit }, count) {
      commit('setOfferCount', count)
    },
    resetOfferCount({ commit }) {
      commit('setOfferCount', 0)
    },
    async initializeOfferCount({ commit, dispatch, rootState }) {
      // すでに初期化済みの場合は何もしない
      if (rootState.auth.isAuthenticating || !rootState.auth.isLoggedIn) return

      const uid = rootState.auth.uid
      if (!uid) return

      // オファー数の初期取得
      await dispatch('fetchOfferCount', uid)

      // 定期的な更新を開始
      setInterval(() => dispatch('fetchOfferCount', uid), 60000)

      commit('setIsInitialized', true)
    },
    async fetchOfferCount({ commit }, uid) {
      try {
        if (!uid) return

        const user = await database.userCollection().findById(uid)
        if (!user || !user.accessibleUserId) return

        const token = await auth.currentUser?.getIdToken()
        if (!token) return
        const response = await spotworkAPI.getPendingOffers(token)
        const count = (response?.data?.offers || []).length
        commit('setOfferCount', count)
      } catch (error) {
        console.error('オファー数の取得に失敗しました:', error)
        commit('setOfferCount', 0)
      }
    }
  }
}
